(function () {
  const dataModeButtons = document.querySelectorAll("[data-mode-button]");

  dataModeButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const modeStyleParent = btn.closest('[data-mode-style="true"]');
      const modeClasses = {
        inverted: "is-inverted",
        darkmode: "is-darkmode",
      };

      const modeButton = btn.getAttribute("data-mode-button");
      if (modeButton in modeClasses) {
        modeStyleParent.classList.add(modeClasses[modeButton]);
      } else {
        // Si le mode n'est pas spécifié ou est "default", supprime toutes les classes de mode
        for (const modeClass of Object.values(modeClasses)) {
          modeStyleParent.classList.remove(modeClass);
        }
      }
    });
  });
})();
